import SettingsCore from './settings-core'

const documents = 'documents'

export default class InventoryProfileSettings extends SettingsCore {
  constructor (store) {
    super(store)
    this._name = 'inventoryProfile'
  }

  _getFields (obj) {
    const settings = this._serverSettings[this._name]
    this._throwErrorIfNull(settings, this._name)
    return settings[obj]
  }

  getDocuments () {
    return this._getFields(documents)
  }
}
